<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel flush">
				<div class="heading">Device Firmware for {{asset.asset_name}}</div>
				<div class="content">
					<div *ngIf="devices === undefined" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading firmware...
					</div>
					<p *ngIf="optime">Latest data as of {{optime | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</p>
					<table *ngIf="devices !== undefined && devices.length > 0" class="firmware-table">
						<tr>
							<th>ID</th>
							<th>Device</th>
							<th>Type</th>
							<th>Target</th>
							<th>App Version</th>
							<th>Boot Version</th>
						</tr>
						<tr *ngFor="let device of devices">
							<td>{{device.dev_id}}</td>
							<td>{{device.dev_lbl}}</td>
							<td>{{device.dev_type}}</td>
							<td>{{device.target}}</td>
							<td>{{device.appver}}</td>
							<td>{{device.bootver}}</td>
						</tr>
					</table>
					<p *ngIf="devices !== undefined && devices.length === 0">No firmware data has been gathered for this asset.</p>
				</div>
			</div>
		</div>
	</div>
</div>